module.exports = __webpack_public_path__ + "img/closeTip.6e310576.png";